import 'bootstrap/dist/css/bootstrap.min.css';
import Navigation from "../components/navigation";
import Header from "../components/header";
import {Helmet} from "react-helmet-async";
import React, {useEffect, useRef, useState} from "react";
import StandardTextInput from "../components/basic/StandardTextInput";
import Styles from "../styles/main.module.css";
import StandardDropdown from "../components/basic/StandardDropDown";
import StateManager from "../redux/StateManager";
import {
    BOXES_SORT_OPTIONS,
    GENERIC_SORT_ORDERS
} from "../utils/constants";
import {toast, ToastContainer} from "react-toastify";
import _ from "lodash";
import {
    addABoxOnServer, deleteABoxFromServer, listEditableBoxes,
} from "../server-calls";
import StandardButton from "../components/basic/StandardButton";
import {createNewBox, deleteBoxFromCache, updateCache} from "../idb";
import Modal from "react-modal";
import "react-toastify/dist/ReactToastify.css";
import PaginationWithInput from "../components/basic/Pagination";

export default function Boxes() {

    function useIsMobile(breakpoint = 768) {
        const [isMobile, setIsMobile] = useState(false);

        useEffect(() => {
            const checkMobile = () => {
                setIsMobile(window.innerWidth < breakpoint);
            };
            checkMobile();
            window.addEventListener('resize', checkMobile);
            return () => window.removeEventListener('resize', checkMobile);
        }, [breakpoint]);

        return isMobile;
    }

    const isMobile = useIsMobile()
    const [showFormMobile, setShowFormMobile] = useState(false);

    const TOAST_CONTAINER_ID = "boxes-toast-container"

    const deleteConfirmationStyles = {
        content: {
            width: "35%",
            height: "20%",
            margin: "auto",
            padding: "20px",
            boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.1)",
            overflow: "hidden"
        },
        overlay: {
            backgroundColor: "rgba(0, 0, 0, 0.5)",
        }
    };

    let [isDeleteConfirmationOpen, setIsDeleteConfirmationOpen] = useState(false)
    let [showBoxAddForm, setShowBoxAddForm] = useState(false);
    let [boxes, setBoxes] = useState([]);
    let [sortOptions] = useState(BOXES_SORT_OPTIONS)
    let [sortOrders] = useState(GENERIC_SORT_ORDERS)
    let [boxValue, setBoxValue] = useState("");
    let [currentPage, setCurrentPage] = useState(1);
    let [totalPages, setTotalPages] = useState(1);
    let [hasNextPage, setHasNextPage] = useState(false);
    let [pageSize] = useState(15);
    let [hasPreviousPage, setHasPreviousPage] = useState(false);
    let [sortOrder, setSortOrder] = useState(StateManager.getBoxesSortingOrder());
    let [sortOption, setSortOption] = useState(StateManager.getBoxesSortingKey());
    let [searchValue, setSearchValue] = useState("")
    let [searchPerformed, setSearchPerformed] = useState(false);
    let [toBeDeletedRecord, setToBeDeletedRecord] = useState("");
    let [isBoxAddButtonDisabled, setIsBoxAddButtonDisabled] = useState(false);

    let navigationRef = useRef()

    const openBoxForm = (value) => {
        setShowBoxAddForm(value)
        if (isMobile)
            setShowFormMobile(value)
    }

    const startSocket = () => {
        if (StateManager.isCacheComplete())
            navigationRef.current?.handleSocket()
    }

    async function startingOperations(search = "") {
        startSocket()
        renderListing(search)

    }

    async function renderListing(search = "", showLoader = false, loadingMessage = "loading boxes") {

        console.log("rendering listing")

        if (showLoader) {
            toast.loading(loadingMessage, {containerId: TOAST_CONTAINER_ID})
        }

        let boxesData = await listEditableBoxes(StateManager.getToken(), {
            pageNumber: currentPage,
            pageSize: pageSize,
            sortOption: sortOption,
            ascending: sortOrder === "ascending" || false,
            search
        })


        setBoxes(boxesData.boxes)
        setHasNextPage(boxesData.hasNext)
        setHasPreviousPage(boxesData.hasPrevious)
        setTotalPages(boxesData.totalPages)
        setCurrentPage(boxesData.pageNumber)

        if (showLoader) {
            toast.dismiss({containerId: TOAST_CONTAINER_ID})
        }
    }

    function handleSortOrder(order) {
        console.log(order)
        StateManager.setBoxesSortingOrder(order)
        setSortOrder(order)
    }

    function handleSortOption(option) {
        console.log(option)
        StateManager.setBoxesSortingKey(option)
        setSortOption(option)
    }

    useEffect(() => {
        console.log("I am triggered.")
        toast.promise(startingOperations(), {
            pending: "loading data",
            error: "server error occurred"
        }, {containerId: TOAST_CONTAINER_ID}).catch((error) => {
            toast.dismiss({containerId: TOAST_CONTAINER_ID})
            console.error(error)
        })

    }, [sortOrder, sortOption, currentPage]);

    function nextPage() {
        currentPage = currentPage + 1;
        setCurrentPage(currentPage);
    }

    function previousPage() {
        currentPage = currentPage - 1;
        setCurrentPage(currentPage);
    }

    async function saveBox() {
        if (_.isEmpty(boxValue)) {
            toast.error("Please fill box name field.", {containerId: TOAST_CONTAINER_ID})
            return true
        }

        setIsBoxAddButtonDisabled(true)

        toast.loading("adding box", {containerId: TOAST_CONTAINER_ID})

        try {
            let newBox = await addABoxOnServer(StateManager.getToken(), {name: boxValue})
            await createNewBox(newBox)
            toast.dismiss({containerId: TOAST_CONTAINER_ID})
            toast.success("box added successfully.", {containerId: TOAST_CONTAINER_ID})
            setIsBoxAddButtonDisabled(false)
            if(isMobile)
                setShowFormMobile(false)
            renderListing()
        } catch (e) {
            toast.dismiss({containerId: TOAST_CONTAINER_ID})
            toast.error(e.response.data.message, {containerId: TOAST_CONTAINER_ID})
            setIsBoxAddButtonDisabled(false)
        }

    }

    async function performSearch() {
        setSearchPerformed(true)
        if (_.isEmpty(searchValue)) {
            toast.error(`Search string is empty`, {containerId: TOAST_CONTAINER_ID})
            return
        }
        renderListing(searchValue, true, "searching..")
    }

    function clearSearch() {
        setSearchPerformed(false)
        setSearchValue("")
        renderListing()
    }

    function deleteBox(name) {
        setIsDeleteConfirmationOpen(true)
        setToBeDeletedRecord(name)
    }

    async function proceedWithDelete() {
        try {
            setIsDeleteConfirmationOpen(false)
            toast.loading(`deleting box`, {containerId: TOAST_CONTAINER_ID})
            await deleteABoxFromServer(StateManager.getToken(), {name: toBeDeletedRecord})
            await deleteBoxFromCache(toBeDeletedRecord)
            toast.dismiss({containerId: TOAST_CONTAINER_ID})
            toast.success(`box delete success`, {containerId: TOAST_CONTAINER_ID})
            renderListing()
        } catch (e) {
            console.error(e)
            toast.dismiss({containerId: TOAST_CONTAINER_ID})
            toast.error("some error occurred", {containerId: TOAST_CONTAINER_ID})
        }
    }

    function closeDeleteConfirmationModal() {
        setIsDeleteConfirmationOpen(false)
    }

    const handleBeforeNewBoxInput = (e) => {
        const regex = /^[a-zA-Z0-9_]+$/;
        if (!regex.test(e.data)) {
            e.preventDefault(); // stop input if not valid
        }
    };

    return (
        <>
            <Helmet>
                <title>Folders</title>
            </Helmet>
            <Header></Header>
            <div className="container-fluid" style={{height: '100%'}}>
                <div style={{height: "100vh"}} className="row">
                    <div className="d-none d-md-block col-md-1 col-lg-1 col-xl-1 p-0">
                        <Navigation
                            ref={navigationRef}
                            isCallbackNeeded={false}
                            handlerFunction={updateCache}
                        />
                    </div>
                    <div className="col-md-3 col-lg-3 col-xl-3 p-0" style={{border: "1px solid grey"}}>
                        <button onClick={() => openBoxForm(true)} className={Styles.StandardButton}
                                style={{margin: "5px 0 0 0", paddingTop: 0, paddingBottom: 0}}>Add Folder
                        </button>
                        <br></br>
                        <StandardTextInput value={searchValue} onChange={(value) => setSearchValue(value)}
                                           styles={{height: "2vh", width: "20vh"}}
                                           placeholder="Search here">
                        </StandardTextInput>&nbsp;

                        {!searchPerformed && (<button onClick={performSearch} className={Styles.StandardButton}
                                                      style={{paddingTop: 0, paddingBottom: 0}}>Search
                        </button>)}

                        {searchPerformed && (<button onClick={clearSearch} className={Styles.StandardButton}
                                                     style={{paddingTop: 0, paddingBottom: 0}}>Clear
                        </button>)}

                        <br></br>
                        <StandardDropdown onChange={(e) => handleSortOption(e.target.value)}
                                          selectedValue={sortOption} name="Sort Option"
                                          options={sortOptions}></StandardDropdown>&nbsp;
                        <StandardDropdown onChange={(e) => handleSortOrder(e.target.value)}
                                          selectedValue={sortOrder} name="Sort Order"
                                          options={sortOrders}></StandardDropdown><br></br><br></br>
                        <PaginationWithInput totalPages={totalPages} currentPage={currentPage}
                                             onPageChange={(e) => {
                                                 setCurrentPage(e)
                                             }}/>
                        <br></br>
                        <ul id="boxes-list" className="p-0"
                            style={{listStyle: "none", width: "100%", borderTop: "1px solid grey"}}>
                            {boxes.map((box, key) => (
                                <li key={box.id} id={box.id} style={{
                                    display: "flex",
                                    width: "100%",
                                    cursor: "pointer",
                                    justifyContent: "space-between",
                                    margin: "10px 0 10px 0",
                                }}><span style={{
                                    marginLeft: "5px",
                                    float: "left",
                                }}>{box.name}</span>
                                    <button disabled={isBoxAddButtonDisabled} onClick={() => deleteBox(box.name)}
                                            style={{float: "right", marginRight: "5px",}}>Delete
                                    </button>
                                </li>
                            ))}

                            {_.isEmpty(boxes) && (<><br></br><span>Nothing to show</span></>)}
                        </ul>
                    </div>
                    <div style={{
                        maxHeight: isMobile ? "100vh" : "90vh",
                        overflowY: "hidden",
                        position: isMobile ? 'fixed' : 'static',
                        top: 0,
                        right: 0,
                        height: isMobile ? '100vh' : 'auto',
                        width: isMobile ? '100%' : undefined,
                        backgroundColor: '#fff',
                        zIndex: isMobile ? 1050 : 'auto',
                        transition: 'transform 0.3s ease-in-out',
                        transform: isMobile
                            ? showFormMobile
                                ? 'translateX(0%)'
                                : 'translateX(100%)'
                            : 'none'
                    }}
                         className={`${
                             isMobile ? '' : 'd-none d-md-block col-md-7 col-lg-7 col-xl-7'
                         }`}>

                        {isMobile && (
                            <div className="p-2 text-end border-bottom">
                                <button
                                    className="btn btn-sm btn-outline-secondary"
                                    onClick={() => openBoxForm(false)}
                                >
                                    Back
                                </button>
                            </div>
                        )}

                        {showBoxAddForm && (
                            <div style={{width: "100%"}}>
                                <label>Only Alphanumeric and "_" is allowed.</label><br></br>
                                <label><strong>Folder Name:</strong></label>&nbsp;&nbsp;&nbsp;
                                <StandardTextInput handleBeforeInput={handleBeforeNewBoxInput} value={boxValue}
                                                   styles={{width: "30%"}}
                                                   onChange={(value) => setBoxValue(value)}/><br></br>
                                <StandardButton onClick={saveBox} innerText={"Save Folder"}/>
                            </div>)}
                    </div>
                </div>
                <Modal
                    style={deleteConfirmationStyles}
                    isOpen={isDeleteConfirmationOpen}
                    onRequestClose={closeDeleteConfirmationModal}
                    ariaHideApp={false}
                >
                    <h4>Confirm Delete</h4><b></b>
                    <span>Box and it's messages will be permanently deleted. You sure ?</span><br></br><br></br>
                    <div style={{float: "right", display: "flex"}}>
                        <button
                            style={{color: "white", float: "right", marginRight: "20px", backgroundColor: "green"}}
                            onClick={closeDeleteConfirmationModal}>Cancel
                        </button>
                        <button onClick={proceedWithDelete}
                                style={{color: "white", float: "right", backgroundColor: "red"}}>Delete
                        </button>
                    </div>
                </Modal>
            </div>

            <ToastContainer containerId={TOAST_CONTAINER_ID}/>
        </>
    );
}